var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "location_on"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_368_7829",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.522949,
    y: 0.834473,
    width: 17.0001,
    height: 17.0001,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_368_7829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "location_on_2",
    d: "M9.02313 9.33458C9.41272 9.33458 9.74622 9.19586 10.0237 8.91843C10.3011 8.641 10.4398 8.30749 10.4398 7.91791C10.4398 7.52832 10.3011 7.19481 10.0237 6.91738C9.74622 6.63995 9.41272 6.50124 9.02313 6.50124C8.63355 6.50124 8.30004 6.63995 8.02261 6.91738C7.74518 7.19481 7.60646 7.52832 7.60646 7.91791C7.60646 8.30749 7.74518 8.641 8.02261 8.91843C8.30004 9.19586 8.63355 9.33458 9.02313 9.33458ZM9.02313 14.5408C10.4634 13.2186 11.5318 12.0174 12.2284 10.9372C12.9249 9.85698 13.2731 8.89777 13.2731 8.05957C13.2731 6.77276 12.8629 5.71911 12.0424 4.89863C11.2219 4.07814 10.2155 3.66789 9.02313 3.66789C7.83077 3.66789 6.82434 4.07814 6.00385 4.89863C5.18336 5.71911 4.77312 6.77276 4.77312 8.05957C4.77312 8.89777 5.12138 9.85698 5.81791 10.9372C6.51444 12.0174 7.58285 13.2186 9.02313 14.5408ZM9.02313 16.4179C7.12243 14.8006 5.70281 13.2983 4.76426 11.9111C3.82572 10.524 3.35645 9.24013 3.35645 8.05957C3.35645 6.28873 3.92607 4.87797 5.06531 3.82727C6.20455 2.77657 7.52382 2.25122 9.02313 2.25122C10.5224 2.25122 11.8417 2.77657 12.981 3.82727C14.1202 4.87797 14.6898 6.28873 14.6898 8.05957C14.6898 9.24013 14.2205 10.524 13.282 11.9111C12.3435 13.2983 10.9238 14.8006 9.02313 16.4179Z",
    fill: "#676F83"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.b2ce273d67789a5505f0d9d2e7e534b5.svg";
export { ForwardRef as ReactComponent };